webpackJsonp([0],{

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(896)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(890),
  /* template */
  __webpack_require__(901),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 890:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_services_pregao_server_time__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_components_base_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_components_base_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__default_components_base_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_leiloes_services_pregao__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rogeriomenezes_comunicator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rogeriomenezes_comunicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rogeriomenezes_comunicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lote_imagens__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lote_imagens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lote_imagens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_leiloes_helpers_LoteStatus__ = __webpack_require__(10);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ApresentacaoLotes',
  extends: __WEBPACK_IMPORTED_MODULE_1__default_components_base_vue___default.a,
  data: function data() {
    return {
      isComConnected: 0,
      leilao: {},
      pregao: null,
      lote: {
        numero: 0,
        imagem: null,
        descricao: '-',
        valorInicial: 0.00,
        valorIncremento: 0.00,
        valorMinimo: 0.00,
        valorMeta: 0.00,
        lancePrincipal: null,
        status: null,
        comitente: {
          pessoa: {}
        },
        pregao: null,
        lances: []
      },
      isLoading: false,
      centerContentFolded: false,
      hasNovoLance: false,
      countDownTimer: 10,
      defaultDownTimer: 10,
      videos: {},
      videoSrc: null,
      limpo: !!this.$route.query.limpo
    };
  },
  created: function created() {
    var _this = this;

    this.$loaderOverlay.open().message('Aguarde enquanto carregamos o leilão');
    __WEBPACK_IMPORTED_MODULE_3__domain_leiloes_services_pregao__["a" /* default */].find(this.$route.params.id).then(function (response) {
      _this.$loaderOverlay.hide();
      _this.isLoading = false;
      _this.leilao = response.data.leilao;

      _this.lote = response.data.lote;
      _this.pregao = response.data.pregao;

      __WEBPACK_IMPORTED_MODULE_3__domain_leiloes_services_pregao__["a" /* default */].videos(_this.$route.params.id).then(function (response) {
        _this.videos = response.data;
        console.log(response);
      }).catch(function (error) {
        alert('Não foi possível carregar os vídeos do pregão');
        console.log(error);
      });

      if (_this.pregao !== null) {
        window.setTimeout(function () {
          _this.centerContentFolded = true;
          _this.carregaPregao();
        }, 500);
      }
    }).catch(function (response) {
      _this.$loaderOverlay.hide();

      window.responseError(response);
      console.log(response);
    });
  },

  computed: {
    filteredLances: function filteredLances() {
      var data = this.lote.lances;
      if (!Array.isArray(data)) {
        data = [];
      }

      data = data.slice().sort(function (a, b) {
        a = Number(a['valor']);
        b = Number(b['valor']);
        return (a === b ? 0 : a > b ? 1 : -1) * -1;
      });

      return data.slice(0, 5);
    },
    lanceLocalidade: function lanceLocalidade() {
      return this.testHasProperty() ? this.filteredLances[0].arrematante.pessoa.essencial.cidade + ' - ' + this.filteredLances[0].arrematante.pessoa.essencial.uf : '-';
    },
    lanceData: function lanceData() {
      return this.testHasProperty() ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.filteredLances[0].data.date).format('L') + ' - ' + __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.filteredLances[0].data.date).format('LTS') : '-';
    },
    valor: function valor() {
      return this.testHasProperty() ? this.filteredLances[0].valor : 0;
    },
    apelido: function apelido() {
      return this.testHasProperty() ? this.filteredLances[0].arrematante.apelido : '-';
    },
    timerPregao: function timerPregao() {
      if (typeof this.leilao['timerPregao'] === 'undefined') {
        return 10;
      }
      return parseInt(+this.leilao.timerPregao);
    },
    timerPregaoFormatado: function timerPregaoFormatado() {
      var timer = Number(this.countDownTimer);
      if (timer < 60) {
        return '00:' + ('0' + timer).slice(-2);
      }
      var hora = Math.floor(timer / 60);
      var minutos = timer % 60;
      return ('0' + hora).slice(-2) + ':' + ('0' + minutos).slice(-2);
    },
    minimoStyle: function minimoStyle() {
      console.log(Number(this.valor), Number(this.lote.valorMinimo));
      return {
        'minimo-superado': Number(this.valor) >= Number(this.lote.valorMinimo)
      };
    },

    Status: function Status() {
      return __WEBPACK_IMPORTED_MODULE_7__domain_leiloes_helpers_LoteStatus__;
    },
    statusLote: function statusLote() {
      if (this.lote.status === null) {
        return '-';
      }
      if (typeof this.Status.Status[this.lote.status] !== 'undefined') {
        return this.Status.Status[this.lote.status].titulo;
      }
      return 'Status inválido';
    },
    colorStatus: function colorStatus() {
      if (this.lote.status === null) {
        return '#FFFFFF';
      }
      if (typeof this.Status.Status[this.lote.status]['color'] !== 'undefined') {
        return this.Status.Status[this.lote.status]['color'];
      }
      return '#FFFFFF';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.comunicator = __WEBPACK_IMPORTED_MODULE_4_rogeriomenezes_comunicator___default.a.connect("wss://ws.rogeriomenezes.com.br:8443/ws");
    this.comunicator.on('lance', this.onLance);
    this.comunicator.on('status', this.onStatus);
    this.comunicator.on('statusLeilao', this.onStatusLeilao);
    this.comunicator.on('tempo', this.onTempo);
    this.comunicator.on('mudaLote', this.onMudaLote);
    this.comunicator.on('lanceDeletado', this.onLanceDeletado);
    this.comunicator.on('alteracaoIncremento', this.onAlteracaoIncremento);
    this.comunicator.on('alteracaoTempo', this.onAlteracaoTempo);
    this.comunicator.on('comitenteDecisaoStatusLote', this.onComitenteDecisaoStatusLote);
    this.comunicator.on('com/connect', function (env) {
      _this2.isComConnected = 1;
    });
    this.comunicator.on('com/disconnect', function (env) {
      _this2.isComConnected = 2;
    });
    window.setTimeout(function () {
      if (_this2.isComConnected !== 1) {
        _this2.isComConnected = 2;
      }
    }, 4000);

    this._showMenu(false);
    this._showHeader(true);
    this._showFooter(false);
    this._menuFolded(false);
    this.$nextTick(function () {
      _this2.$root.$el.classList.add('full-height');
      _this2.$root.$el.classList.add('flex-f-height');
    });
  },
  destroyed: function destroyed() {
    this.$root.$el.classList.remove('full-height');
    this.$root.$el.classList.remove('flex-f-height');
  },

  methods: {
    onLance: function onLance(data) {
      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return;
      }
      this.lote.lances.unshift(data.lote.lance);
      this.lote.lancePrincipal = this.filteredLances.length > 0 ? this.filteredLances.slice(0, 1).shift() : null;
      this.remoteNovoLance({
        id: data.lote.id,
        status: data.lote.status,
        lancePrincipal: data.lote.lance
      }, data.lote.lance);
    },
    onStatus: function onStatus(data) {
      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return;
      }
      delete this.lote.pregao;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(this.lote, data.lote);
      this.mountTimerCountdown();
    },
    onStatusLeilao: function onStatusLeilao(data) {},
    onTempo: function onTempo(data) {
      var _this3 = this;

      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return;
      }
      this.lote.pregao.dataAbertura.date = data.lote.tempo.date;
      if (this.filteredLances.length > 0) {
        this.lote.lances[0].data = { date: data.lote.tempo };
      }
      this.$nextTick(function () {
        _this3.mountTimerCountdown();
      });
    },
    onMudaLote: function onMudaLote(data) {
      if (!this.validateComunication(data)) {
        return;
      }
      this.carregaPregao();
    },
    onLanceDeletado: function onLanceDeletado(data) {
      if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
        return;
      }
      if (this.lote.lances.length === 0) {
        return;
      }
      for (var i = 0, len = this.lote.lances.length; i < len; ++i) {
        if (this.lote.lances[i].id === data.lote.lance) {
          this.lote.lances.splice(i, 1);
          break;
        }
      }
    },
    onAlteracaoIncremento: function onAlteracaoIncremento(data) {},
    onAlteracaoTempo: function onAlteracaoTempo(data) {
      if (!this.validateComunication(data)) {
        return;
      }
      this.leilao.timerPregao = data.tempo;
      var that = this;
      this.$nextTick(function () {
        that.updateDefaultTimerPregao(that.leilao['timerPregao']);
        that.mountTimerCountdown();
      });
    },
    onComitenteDecisaoStatusLote: function onComitenteDecisaoStatusLote(data) {
      console.log(data);
    },
    validateComunication: function validateComunication(event) {
      if (typeof event['leilao'] === 'undefined') {
        return false;
      }
      if (typeof event['leilao']['id'] !== 'undefined') {
        return event['leilao']['id'] === this.leilao.id;
      }
      return event['leilao'] === this.leilao.id;
    },
    validateComunicationLote: function validateComunicationLote(event) {
      if (typeof event['lote'] === 'undefined') {
        return false;
      }
      if (typeof event.lote['id'] === 'undefined') {
        if (event.lote === this.lote.id) {
          return true;
        }
      } else {
        if (event.lote.id === this.lote.id) {
          return true;
        }
      }
      return false;
    },
    round: function round(number, precision) {
      var factor = Math.pow(10, precision);
      var tempNumber = number * factor;
      var roundedTempNumber = Math.round(tempNumber);
      return roundedTempNumber / factor;
    },
    testHasProperty: function testHasProperty() {
      return this.filteredLances.length > 0;
    },
    toggleKeyboard: function toggleKeyboard(v) {
      this.centerContentFolded = v;
    },

    reajustaTimerPregao: function reajustaTimerPregao(newTimer) {
      var _this4 = this;

      this.leilao.timerPregao = this.countDownTimer = newTimer;
      this.$nextTick(function () {
        _this4.mountTimerCountdown();
      });
      console.log('Reajustando timer do pregão');
    },
    carregaPregao: function carregaPregao() {
      var _this5 = this;

      var that = this;
      this.videoSrc = null;
      __WEBPACK_IMPORTED_MODULE_3__domain_leiloes_services_pregao__["a" /* default */].find(this.$route.params.id).then(function (response) {
        _this5.$loaderOverlay.hide();
        _this5.isLoading = false;
        _this5.leilao = response.data.leilao;
        _this5.lote = response.data.lote;
        if (typeof _this5.videos[_this5.lote.numero] !== 'undefined') {
          console.log(_this5.videos[_this5.lote.numero]);
          _this5.videoSrc = _this5.videos[_this5.lote.numero];
        }
        _this5.pregao = response.data.pregao;
        if (_this5.pregao !== null) {
          window.setTimeout(function () {
            _this5.centerContentFolded = true;
            that.$nextTick(function () {
              if (typeof that.leilao['timerPregao'] !== 'undefined') {
                that.updateDefaultTimerPregao(that.leilao['timerPregao']);
                that.mountTimerCountdown();
              }
            });
          }, 500);
        }
      }).catch(function (response) {
        _this5.$loaderOverlay.hide();

        window.responseError(response);
        console.log(response);
      });
    },
    reset: function reset() {
      this.countDownTimer = this.defaultDownTimer;
    },
    updateDefaultTimerPregao: function updateDefaultTimerPregao(seconds) {
      this.defaultDownTimer = parseInt(seconds);
      this.countDownTimer = parseInt(seconds);
    },
    mountTimerCountdown: function mountTimerCountdown() {
      var that = this;
      this.$nextTick(function () {
        console.log('Countdown execute...');
        if (typeof this.$intervalCronometro !== 'undefined') {
          window.clearInterval(that.$intervalCronometro);
          that.reset();
        }
        if (typeof this.lote.pregao === 'undefined') {
          console.log('Lote não está em pregão, por isso não inicia o cronômetro.');
          return;
        }
        if (this.lote.pregao !== null) {
          console.log('Inicia os ajustes do cronômetro.', this.lote.pregao);

          var dataInicio = new Date(this.lote.pregao.dataAbertura.date);

          if (this.lote.lances.length > 0) {
            var dataUltimoLance = new Date(this.lote.lances[0].data.date);
            if (dataUltimoLance.getTime() >= dataInicio.getTime()) {
              dataInicio = dataUltimoLance;
            }
          } else {}
          dataInicio.setSeconds(dataInicio.getSeconds() + this.timerPregao + 1);
          var intervalFcn = function intervalFcn() {
            var timeNow = void 0;
            if (__WEBPACK_IMPORTED_MODULE_0__utils_services_pregao_server_time__["a" /* serverTime */] > 0) {
              timeNow = __WEBPACK_IMPORTED_MODULE_0__utils_services_pregao_server_time__["b" /* timeNow */]();
            } else {
              timeNow = new Date().getTime();
            }
            var dataFim = timeNow;
            var distance = dataInicio.getTime() - dataFim;
            var seconds = Math.floor(distance / 1000);

            if (distance < 1) {
              window.clearInterval(that.$intervalCronometro);
              that.countDownTimer = 0;
            } else {
              that.countDownTimer = seconds;
            }
          };
          intervalFcn();
          this.$intervalCronometro = window.setInterval(intervalFcn, 1000);
        }
      });
    },
    remoteNovoLance: function remoteNovoLance(lote, lance) {
      this.hasNovoLance = true;
      this.$nextTick(function () {
        var _this6 = this;

        window.setTimeout(function () {
          _this6.hasNovoLance = false;
        }, 100);
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(this.lote, lote);

      this.mountTimerCountdown();
    },
    calcPercentTimer: function calcPercentTimer(percent) {
      var downTimer = this.timerPregao;
      return downTimer * (percent / 100);
    },
    videoEnded: function videoEnded() {
      this.videoSrc = null;
    }
  },
  components: { LoteImagens: __WEBPACK_IMPORTED_MODULE_6__lote_imagens___default.a }
});

/***/ }),

/***/ 891:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lote-imagens',
  props: ['lote', 'video'],
  data: function data() {
    return {
      loteAtual: null,
      url: null,
      imagem: null,
      imagemIndex: 0,
      imagens: [],
      videoAtivo: false
    };
  },

  watch: {
    lote: function lote() {
      this.montaAnimacao();
    },
    video: function video() {
      if (this.video !== null) {
        this.videoAtivo = true;
        this.playVideo();
      } else {
        this.videoAtivo = false;
      }
    }
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    montaAnimacao: function montaAnimacao() {
      var _this = this;

      var lote = this.lote;
      this.videoAtivo = false;
      if (this.loteAtual === lote.id) {
        return;
      }
      var url = lote.imagem.split('/');
      url.splice(-1, 1);
      url = url.join('/') + '/';
      this.url = url;
      this.imagens = [];
      lote.fotos.forEach(function (foto) {
        _this.imagens.push(foto.url);
      });
      this.imagem = this.imagens[0];
      window.clearInterval(this.$interval);
      this.$interval = setInterval(function () {
        _this.imagemIndex++;
        if (typeof _this.imagens[_this.imagemIndex] === 'undefined') {
          _this.imagemIndex = 0;
          if (_this.video !== null) {
            _this.videoAtivo = true;
          }
        }
        _this.imagem = _this.imagens[_this.imagemIndex];
      }, 2000);
    },

    onEnd: function onEnd() {
      this.videoAtivo = false;
      this.imagemIndex = 0;
      this.montaAnimacao();
    },
    playVideo: function playVideo() {
      if (!this.videoAtivo) return;
      window.setTimeout(function () {
        var videoFrame = document.getElementById('loteVideo');
        if (videoFrame.paused || videoFrame.ended) {
          videoFrame.play();
        }
      }, 200);
    }
  },
  components: {}
});

/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(885)(true);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Archivo+Black);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Archivo);", ""]);

// module
exports.push([module.i, ".slidelotes{background-color:#212121;height:100%;width:100%;display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;-ms-flex-direction:row;flex-direction:row;min-width:0;color:#fff;font-family:Archivo Black,sans-serif}.slidelotes .col1,.slidelotes .col2{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1}.slidelotes .col1{-ms-flex-direction:column;flex-direction:column;min-width:76vw;max-width:76vw}.slidelotes .col1.full{min-width:100vw;max-width:100vw}.slidelotes .col2{min-width:24vw;max-width:24vw;background:#141414}.slidelotes .header,.slidelotes .header .lote-num{display:-ms-flexbox;display:flex}.slidelotes .header .lote-num{min-width:120px;padding:10px;font-size:30px;font-weight:700;-ms-flex:0 auto;flex:0 auto;text-align:center;line-height:1;-ms-flex-direction:column;flex-direction:column;-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.slidelotes .header .lote-num .lote-num-content{font-size:54px}.slidelotes .header .lote-desc{-ms-flex:1;flex:1;background:#fff;color:#000;font-weight:700;font-size:40px;line-height:1;padding:10px 20px;text-transform:uppercase}.slidelotes .images{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;overflow:hidden;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-direction:column;flex-direction:column}.slidelotes .images,.slidelotes .images .image{position:relative;height:100%}.slidelotes .images img{position:absolute;top:0;left:0;right:0;width:100%;height:auto}.slidelotes .images video{position:absolute;top:0;left:0;right:0;width:100%;height:100%}.slidelotes .col2,.slidelotes .t1{-ms-flex-direction:column;flex-direction:column}.slidelotes .t1{padding:30px;font-size:28px;font-weight:700;font-family:Archivo,sans-serif;text-transform:uppercase;display:-ms-flexbox;display:flex;text-align:center}.slidelotes .t1 strong{background:#fff;color:#000;padding:10px;font-weight:700;font-size:32px;font-family:Archivo Black,sans-serif}.slidelotes .t1 .status-6{background-color:#00ff01}.slidelotes .t1 .status-2{background-color:#ff4a4a}.slidelotes .t1 .status-3,.slidelotes .t1 .status-4{background-color:#ff4a4a;font-size:70%}.slidelotes .t-comitente{padding:30px;text-align:center}.slidelotes .t-comitente img{max-width:60%}.slidelotes .t-logo{padding:30px;text-align:center}.slidelotes .t-logo img{max-width:60%}.flex-f-height{display:-ms-flexbox;display:flex;height:100%!important}", "", {"version":3,"sources":["/opt/buildhome/repo/src/app/website/apresentacao-lotes/assets/scss/default.scss"],"names":[],"mappings":"AAGA,YACE,yBAA0B,AAC1B,YAAa,AACb,WAAY,AACZ,oBAAqB,AACrB,aAAc,AACd,WAAY,AACR,OAAQ,AACZ,uBAAwB,AACpB,mBAAoB,AACxB,YAAa,AACb,WAAe,AACf,oCAAwC,CACzC,AACD,oCACI,oBAAqB,AACrB,aAAc,AACd,WAAY,AACR,MAAQ,CACf,AACD,kBACI,0BAA2B,AACvB,sBAAuB,AAC3B,eAAgB,AAChB,cAAgB,CACnB,AACD,uBACM,gBAAiB,AACjB,eAAiB,CACtB,AACD,kBACI,eAAgB,AAChB,eAAgB,AAChB,kBAAoB,CACvB,AAKD,kDAHI,oBAAqB,AACrB,YAAc,CAqBjB,AAnBD,8BACM,gBAAiB,AACjB,aAAc,AACd,eAAgB,AAChB,gBAAkB,AAClB,gBAAiB,AACb,YAAa,AACjB,kBAAmB,AACnB,cAAe,AAGf,0BAA2B,AACvB,sBAAuB,AAC3B,0BAA2B,AACvB,qBAAsB,AAC1B,sBAAuB,AACnB,mBAAoB,AACxB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,gDACQ,cAAgB,CACvB,AACD,+BACM,WAAY,AACR,OAAQ,AACZ,gBAAoB,AACpB,WAAY,AAEZ,gBAAkB,AAClB,eAAgB,AAChB,cAAe,AACf,kBAAmB,AACnB,wBAA0B,CAC/B,AACD,oBACI,oBAAqB,AACrB,aAAc,AACd,WAAY,AACR,OAAQ,AACZ,gBAAiB,AAEjB,sBAAuB,AACnB,8BAA+B,AAEnC,0BAA2B,AACvB,qBAAuB,CAC9B,AACD,+CAPI,kBAAmB,AAGnB,WAAa,CAOhB,AACD,wBACM,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,WAAY,AACZ,WAAa,CAClB,AACD,0BACM,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,WAAY,AACZ,WAAa,CAClB,AAKD,kCAHI,0BAA2B,AACvB,qBAAuB,CAa9B,AAXD,gBACI,aAAc,AACd,eAAgB,AAChB,gBAAkB,AAClB,+BAAkC,AAClC,yBAA0B,AAC1B,oBAAqB,AACrB,aAAc,AAGd,iBAAmB,CACtB,AACD,uBACM,gBAAoB,AACpB,WAAY,AACZ,aAAc,AACd,gBAAkB,AAClB,eAAgB,AAChB,oCAAwC,CAC7C,AACD,0BACM,wBAA0B,CAC/B,AACD,0BACM,wBAA0B,CAC/B,AACD,oDACM,yBAA0B,AAC1B,aAAe,CACpB,AACD,yBACI,aAAc,AACd,iBAAmB,CACtB,AACD,6BACM,aAAe,CACpB,AACD,oBACI,aAAc,AACd,iBAAmB,CACtB,AACD,wBACM,aAAe,CACpB,AACD,eACE,oBAAqB,AACrB,aAAc,AACd,qBAAwB,CACzB","file":"default.scss","sourcesContent":["\n@import url(\"https://fonts.googleapis.com/css?family=Archivo+Black\");\n@import url(\"https://fonts.googleapis.com/css?family=Archivo\");\n.slidelotes {\n  background-color: #212121;\n  height: 100%;\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  min-width: 0;\n  color: #FFFFFF;\n  font-family: 'Archivo Black',sans-serif;\n}\n.slidelotes .col1, .slidelotes .col2 {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex: 1;\n        flex: 1;\n}\n.slidelotes .col1 {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    min-width: 76vw;\n    max-width: 76vw;\n}\n.slidelotes .col1.full {\n      min-width: 100vw;\n      max-width: 100vw;\n}\n.slidelotes .col2 {\n    min-width: 24vw;\n    max-width: 24vw;\n    background: #141414;\n}\n.slidelotes .header {\n    display: -ms-flexbox;\n    display: flex;\n}\n.slidelotes .header .lote-num {\n      min-width: 120px;\n      padding: 10px;\n      font-size: 30px;\n      font-weight: bold;\n      -ms-flex: 0 auto;\n          flex: 0 auto;\n      text-align: center;\n      line-height: 1;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: column;\n          flex-direction: column;\n      -ms-flex-line-pack: center;\n          align-content: center;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.slidelotes .header .lote-num .lote-num-content {\n        font-size: 54px;\n}\n.slidelotes .header .lote-desc {\n      -ms-flex: 1;\n          flex: 1;\n      background: #FFFFFF;\n      color: #000;\n      /*margin: 40px 0;*/\n      font-weight: bold;\n      font-size: 40px;\n      line-height: 1;\n      padding: 10px 20px;\n      text-transform: uppercase;\n}\n.slidelotes .images {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex: 1;\n        flex: 1;\n    overflow: hidden;\n    position: relative;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    height: 100%;\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n.slidelotes .images .image {\n      height: 100%;\n      position: relative;\n}\n.slidelotes .images img {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      width: 100%;\n      height: auto;\n}\n.slidelotes .images video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      width: 100%;\n      height: 100%;\n}\n.slidelotes .col2 {\n    -ms-flex-direction: column;\n        flex-direction: column;\n}\n.slidelotes .t1 {\n    padding: 30px;\n    font-size: 28px;\n    font-weight: bold;\n    font-family: 'Archivo',sans-serif;\n    text-transform: uppercase;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    text-align: center;\n}\n.slidelotes .t1 strong {\n      background: #FFFFFF;\n      color: #000;\n      padding: 10px;\n      font-weight: bold;\n      font-size: 32px;\n      font-family: 'Archivo Black',sans-serif;\n}\n.slidelotes .t1 .status-6 {\n      background-color: #00FF01;\n}\n.slidelotes .t1 .status-2 {\n      background-color: #ff4a4a;\n}\n.slidelotes .t1 .status-3, .slidelotes .t1 .status-4 {\n      background-color: #ff4a4a;\n      font-size: 70%;\n}\n.slidelotes .t-comitente {\n    padding: 30px;\n    text-align: center;\n}\n.slidelotes .t-comitente img {\n      max-width: 60%;\n}\n.slidelotes .t-logo {\n    padding: 30px;\n    text-align: center;\n}\n.slidelotes .t-logo img {\n      max-width: 60%;\n}\n.flex-f-height {\n  display: -ms-flexbox;\n  display: flex;\n  height: 100% !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(894);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(886)("2a61132e", content, true, {});

/***/ }),

/***/ 897:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALYAAABHCAYAAACqPr24AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAABKhSURBVHic7Z1/kB3Fccc/E+6wzhJwgCIJpELYgCHYJRxVIC5cjiCAAQMxIoURJoJgILaIY6hSwC47RFDYmPCjCgK2ZSxMEAWxBVVAyQQlCAOxII6SEJkYg4wQEhKyJH5I1ukH6I765o+evdc7b997+6Q7H3fst+rq9s30zM7u9vZ093TPBknbgS4qlMURIYTlQz2ICs3xe0M9gAoVBgMVY1cYkagYu8KIRMXYFUYkKsauMCJRMXaFEYmKsSuMSFSMXWFEomLsCiMSFWNXGJGoGLvCiETHUA+gwnsbko4FzgT2BHYC14UQNg/tqFqjYuwKDSHpYOARoBvYAXxhODA1VKpIhQaQdDjwvxhTPwR8OITwo6EdVXlUErtCM1wOrAohPDXUA2kXFWMPIiRNAL5WULUJWA4sCSGsbdHHdOAE4BBgFPA28DLwOLAwhNBXYgynA58AJmLPfCuwGvi5H4OkDmAOsBewLf4dHMeQYUEI4ZlIPyP267ETeA1YBjydjk/SJOBv48+NIYTrGoz7GOAM4GPYrAHwahzzgyGE9c2uG0nbVaEdHN70hubv7dQWfW2XdEOTtstatF8mY4BG558jaUuLPr7u6LvUmh88/X0taF+QGZ9+TMe6+k2yl8nXjynR7yZJs5rd+0piDy68tNoBPIXd88OAyVjm0hWSXgsh3JoRyl6eJzHJCdADLALWAeOAUzEpdhSwWNLRaVaPpPuAc13Ry8DTsa/9gGNiX3ckY34TmBSPM3qPX7jjLUn/LwH7Y1K2CzgCeETSYSGENwruyZvJmDuAhcBxrngx8Dw2W02LfXYD35VECOF7FKHEG1ohj3Yk9hTXbpV/gJJucXVLk3aPuroXZN4JXz9JeWn+aFJ/cTLmOUokY6RL++2StMa1Ozhtk9DPdbRekh8uaZWrm+nqjnHlK/y4knHvVF4Fyu6bP+d2SWOLxtbKK7Ij/g0FeoG1mIT4L+BFYGMb7Xen7WBgj+whRr1zvqvbLzuIzHSCq/ubEMIq31HUiS9zRackTDjbHc8PIVxTpIun/Ragqf6eoNP1uxzwL+t+9eSF+Ct3fEcI4UFfGa/hy9izBZsVzi7qqJUq0gN8DptmRpUcXDPsjU3BJ2AGzeQCmp8AC4CfAWv9A5HUDXwEm4pnYgaVx5PAvbHtqyGEHa7tmNj2+Nj2qAG4nnbwbnYtcSyeMf/PHf8hNSbZiKkDRXg61o9z7VZFBj/C0RXq8CUxS1Jq3N4TQthaQNubHUiaiqkNGZa1OlF8toe5ooeK6EIIfZJ+Cpwfiz4B1Ksjaq2KLGsk7ncHcdq72E19S5UYGiXaz3ZT2oltnv9imRHSLnZVFdkuaUn82+DKN/g+lZ+OmzKE8urIrFjmp/pNspcISWPjPV6W/N2S3FOvihThYEfv1YJVkp5QvcF7dzLmQlVE0sEy9SPDR5tc97WObmERTRnj8Sjg55KOa+WaagdRms6TtAg4B7i1leuqoP3Nkh4D1jnjpGz7eZJ+hkmGI1rRDwC6gE8mZQ8BV4QQVgzSOXe64zHA0QU0rzdp/zJOEgPvYO7GIkwmPwP3AF9taNztHlouLJb1ihwCPCnpxBJ6WVuIL8vNu9H+ud1ou1zSScB/UPMEDBZ6gFuBg6hNo28WMPVv3PEBkrq8SpVBUhdwgCvK/LreltgXGIv5rd8AvhHLP0bNY9KIUQE+G0J4vkm9x5PAEkzNyxj8P0u2JY5vGzWf9QGYN6QIH3LHGwop1J5XJNPhRhQkndjGPRgIr8gTrvyypM0E5afk0xr0fZqj2Slb+Mg8Bytc3eyCttNc/UJXnqoiDdWBSD83PY/yqsYGJWqsmntF/H2Z1+CcXcqrchcU0bUbKzIZk9yHttnuPY0QwmIaGCsDiD1kUhbgQmr+4RtlxlY2lvXJWL4jaYrvKP6+1RU9kqmJUZ27x9XNKXg5OimHd0rSgak6hBCWAt+MZeOSsbTC993xRSnTygzMu6kZzJuBhwt70q75sdeoDck1HJBIkmbYVYm9xjF2aiSuUDTyYt0k5aXSTkmPyVbkHlNeom9QlNau/RjVG3FLJN0d+/B1zST2MtUM3uxvuqP3EntOMoalrs77uBtK7Fj/YDLupXHMD6resJ3R6N7v6srjJODfJd1Bva+zt4C+M57r2dQ32Qiyt/MKzG20JxZ/ML9M+3izrgROAkZjetgDIYS7G7UJISyV9DL1LsTdgb+/+yfnmyeTpGfGcy6U9JkQwo4QwlpJfwLMxVbhOoEir8/TwEWpUR9C2CrzEt2FuVXBDNfUeIX65+fHWeQS/RcgewZ7u/LRCd1MbP0A4FuSVsbowIb3JOJs4BbMp92JGbyp0bsWM7obRhvuzpL6OODv2m0kaTEwvYEvNKPpwPzZ/kEcDZwp6fwQQqvp7X6MYTxOlzSxUdBNxNMMLGOvozYtb6b+pb8E+GU8/gAwHlgF/Yscx0uahjH1IZhnZQfmrXgqqlCFiF6iM2Qu1JOAw6ltProBCyhaSt7H3AtcRc2AK4I/571xLGDhAv78yyWdBUzFVN7xsWoltXvyRuoJyxZhJN2GvZRTqL1AWeDWT5rxDzBkS+pzW4zptCZtX2jRtlngUb9ft0Hb2U3aZhhRKthIxVAlGkyX0zcL8EdN6ibLQjEbYWqTum7gw03qh3rZvcIAYagYuwubehsh1dfStg2lLrBPi3M3a1tkH1QYhhiqsNUXW+TOlQ2aeU9D5vP3K299wKyiFVyZXTEfW1TJcH2WvRJVqB9SC2Utgqf/OvApV1cXVBTpZgF/Fn9enoW/yjwtP2h6gRagtUIWIrtvC1qAu0MIP5I5Bu6iefzRtVlCQxzPacB5wJGYcOrFjNMngUV1m/Hrd69j71SLmBCZW6kZGvrR1VpPbnhuSTNKjH93Ew3qFkwibZFd4cM9x5YY28WOfmFSt0kFMT+S5jmaaa58ilrj2EhbFjdE+gklaP21f6sFbZ3N1kpibwTeorVDv4P6SL3NmBU7Jtb3YVFs345O/ELIbn4zPXk4oSj25RyKQwjOKyjzqlEfdk8zj8V86pMAnnXH6TJ8N/CPwOeTcr+k7s/3rjvuAe6j/npejf+vo14F7MM8Mae4vh9IxtcVy/+ZBgkNssWrzA/eiyVGvIR55Y4FPg7cRgo1l9irFCWUbKm27s/VXZa03aDaG11a5ZE0q8TbPFwktpd6LzTqQ1K3ailcnm5GQpNFI+5UE+9OpF8QaTcpH8V4WkJ3e9G9kfRRV76m7DUnffuZ188mE1Tjuy1q4khQnh/q1iG0i4kGk4F/lXRoCKGv6A/M9xhTmy51bcdhaUFTy0btyV6Awql6BOBxbAYD+POk7rOY7rwWS40aSKwHrna/57Z6KQYCkhZQW4e4M4RQGPtRAt5ffZSSWKVGUZ1lJOlk4AlZZF/Tr2WFEL4nqZea0dGNxZac4g2BJriGgV0geS9hHba4cRGWvOEXiv4i/n8EeKVEX53ALZL8Q98GfLMgEnAiNn2fiC14TAKuxzJRymIfSbeTV0WaZZjPppbZ8gvgS036HgXcllxLD5Bl/TxKLaHiKOA5mU59Z1N+VHnjcYNaRHu5PtOcuy1qbTBOLzkOaXiqItcqH0U4JdL4APtjk/E3UkUaodvRZ6rIztjWT//990HlVJEi+ERef83TPI0KokELxlIEHztzjPI5lNl1zVODNY123H3jgJ9K+tNWMboxDqIX+KdYtBewSA0kt8wCvrONsQxH7Iu5pnqw+3EO8BxmzHViEvAZWXx4GSwmb/j1UGysdgJjo1vuKuCmWH4n8AfAb0ucK8uw9/2vTolk+u4CV3RBifj93ti3v5a3cMZrjOP5OJZOdyGmRXRis9/Jkj5Vd54Sb06KdiT3BUnbnOSWubBuV/sYjhJ7bizLoteWxd/Lknrv2mpmPDaL5/ASW8qnc/mou1nKG2e7ZTwqH0/dMNdS9cZjaZ1fFrk4S/noxwUp3a6sPGaSe0orwhhNd74ryiT3DEnXYhkSf70LYxiOyGbHH8f/R8p00SPj7/n1TZpiVw1Ar+9eR34RpyHUwrMVGfm4+HNRCOHKNsZUOlE8hLA1ppt9zhXXuYd3deVxHPCYpFNDCM82Iwwh3CMJag9uL8xv+X7FImr+6G9jU+qLJY1rj9EJs3UWpZClCCE8K+lGLCS4m/ymOs0wRnkDr/98shjtK2L5auCSghehE+gt8JB1xL79SrTv+7JI83CSRneQO34rHezuhq0+LumEksydOeLf1wghbJZtcHMutYWvdncx7SQfPgqApK+UjHefA5xFeQ/UePJbRGTnOwVjZO9f3gezJYpigR6m3hvThW2XkfZ9YQzL/WPsXn1bFi+/Hosl8jHa6W5Wux0r0o0x98nNVhMBYowAvL+Y29/fD7rj+8lLynvdsQ8A88zRQT5Ouij52Afu+5iS3HMOIeyQ9CXgsaS9X2HeIykvOt8HsGRhf65uGsdze/vEL8oU9Z0tvGTx3p3YbgJ+R4EeLD6mzkc+EEFQ3dj+cS191e9D5l5JzcbwPtdFrnxrMsX+EPifeOwl2WbyUr4Inv56bBkcahns/QghLJZ0OvmAM+/tepW8fVSElVheZCs63yeYJ6bVtSyJ47xK0v3YXoOTsZfpHeDXwBMNtwTRwAVBtfRVu3O247MuwrDwilQYOgxkPHbm8WjJ3FEPPGsAz12hQg4DnWiQMfe0VoSRuU+iPqqrFXppvsnL9hbtm7VtZ7uBCu9hDEaiwV7Ao5LOw75h4pG6ev4b+Cq2R0bZvS46sWCYRlk2H2pQnuEjkrY1qGuWNlZhGCFI2k7eQh1IlEm12oZ5Asoy9lDjiFbBYBWGHoOdGlaGWZsuDVeosCuoPtUxiJCtvo1J8ztlsRETqPmKt8VNcrqBd6Kfuf+4Qd9TMbVveXAfGpIF7Y+n5gN/J4SwKp4z20wnoxkN/LZBDuYULHBrdatAJlksymRgk98kNF7/BPK++Wyv9XeT/cvHYvuX9wG/jgtZdfdA0tg0Bju23exXNSvGHlx8Evtq2KlJ+fVYSlPm1/0lFrdxK+aLnhdpXiC/Rx/R63QLsAIzlA+R9EwIIdtJ9UpgOvCr+PsVbJfVv8fUvmuwhJCZkWYvSX3AJSGENyKT3oX5zd8EJkraiO04lX4BrAOLEjwQW4HcP75Al8SX4Ugsxtz71y/FNsx5npjoLIszORZj+i4s/vrL2L5/c2MfmUBYKemCZIX1IeCLOD98xdiDi06Ks8rHAd8v2NGqi5r61kXyfKIE+zHQv3QeH/YSSa/EFbgDsE/WpUkAH6Tm9RkP/FsWqCTbv+8ybBeoBcBDvn2svwn77qPHTcCBIYSTHO3s2McxWKDW6hBCLs9S0n5xPFk2/aeB47KZTbU4kzTQ64tYqO/Z1LZZK6Krvsz7O0CRAd2HeWemxL8JrrwZTsEYpf+hxq2+rgf+Mha9DRzk+m6073c6rnWRdr+Cl+Jr2BZxfsvfDiwjJ5fKF0K4GZsFDiWf1pWeO7vWmcClXl1zM4P/TEsHFsN+Zuzfr5f4De6BSmIPFbYDJ1OLUHuUcoFQE7EUsxSvUpNaPVj4aObpylQbj83ATEnjsdiLZ2Ja34kURMphKkkvphtnzDoqlhXtnvVmHOtq4DDV4qW3hBAuju0yZuxscE0pzo1tRmH7DV4ONAzhqBh7aLA3cFuJzTVTCb4Sk1opDsO+9gtm8BWpIh6jsQ04b8R02CzPcg21vac9DoT+2YHsWBb3cxD1sSgTMKbeO/7/SlLfie2gC8bkk4mbcTbBF7BrzBIYphUZkhkqVWTwUeTy7KQ4UaAroUkXoRZh03D/V2mj+nAVtmcImLAqWpfooPa8RwNvRX/8ucDVkqbE3y8p/8GlbD+SohnlHuB25XMtbwBeicZj5olZn/25a+twfcx16ljm2cnGvFX29eHRIYQzQgifjzr7/dR2+92TfDRiJbEHGW9hngJv6FyIeUHOk3R8LHs+hHANtgd4JhVfBj4jKYs7/lUI4RuSzsCyuj+N5SL+PnCz07tfAs5xwVqropH4OqaCgFMfQgjrJV2NeUumY4bZd6PB2IPNAE/E8eUQQrgurgDfL+l1zFDuoZah/na8phQbibmWsY8u4AFJ6zCmX4JtKvSb2N8M4DtJHzcBP4ht1wD/ICkLl9gy2CuPIxFtrTzGGz+aqFY4y38MtZSot+PU3hHy37XMaPqAPq8KREk9CmPc1A3n++6LPuH+j6cq/yHV/jZJ/xOwpIHXQou9qOP5JmI+8fVJXUfB+IrKumIfbwPrs3HG/40+MNXhrsfvODboS+ojEdWS+jBApWNXGJGoGLvCiETF2BVGJCrGrjAiUTF2hRGJirErjEhUjF1hRKKD2uc0KrTGu1QJv8MC/w/18njO58naKQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(891),
  /* template */
  __webpack_require__(900),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 900:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image",
    class: 'lote-img-status' + _vm.lote.status
  }, [(_vm.videoAtivo) ? _c('video', {
    attrs: {
      "id": "loteVideo",
      "autoplay": ""
    },
    on: {
      "ended": _vm.onEnd
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.video,
      "type": "video/mp4"
    }
  })]) : _vm._e(), _vm._v(" "), _c('img', {
    ref: "imagem",
    class: _vm.videoAtivo ? 'hide' : '',
    attrs: {
      "src": _vm.imagem
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full slidelotes"
  }, [_c('div', {
    staticClass: "col1",
    class: {
      'full': _vm.limpo
    }
  }, [(!_vm.limpo) ? _c('div', {
    staticClass: "header",
    staticStyle: {
      "z-index": "99"
    }
  }, [_c('div', {
    staticClass: "lote-num",
    staticStyle: {
      "background-color": "#212121"
    }
  }, [_c('div', [_vm._v("LOTE")]), _vm._v(" "), _c('div', {
    staticClass: "lote-num-content"
  }, [_vm._v(_vm._s(_vm.lote.numero))])]), _vm._v(" "), _c('div', {
    staticClass: "lote-desc"
  }, [_vm._v("\n        " + _vm._s(_vm.lote.titulo) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "images",
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('lote-imagens', {
    attrs: {
      "video": _vm.videoSrc,
      "lote": _vm.lote
    },
    on: {
      "videoEnded": _vm.videoEnded
    }
  })], 1)]), _vm._v(" "), (!_vm.limpo) ? _c('div', {
    staticClass: "col2"
  }, [_c('div', {
    staticClass: "t1",
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('span', [_vm._v("Lance Inicial")]), _vm._v(" "), _c('strong', [_vm._v("R$" + _vm._s(_vm._f("moeda")(_vm.lote.valorInicial)))])]), _vm._v(" "), _c('div', {
    staticClass: "t1",
    staticStyle: {
      "margin-top": "-28px"
    }
  }, [_c('span', [_vm._v("Maior Lance")]), _vm._v(" "), _c('strong', [_vm._v("R$" + _vm._s(_vm._f("moeda")(_vm.valor)))])]), _vm._v(" "), _c('div', {
    staticClass: "t1"
  }, [_c('span', [_vm._v("Status")]), _vm._v(" "), _c('strong', {
    class: 'status-' + _vm.lote.status
  }, [_vm._v(_vm._s(_vm.statusLote))])]), _vm._v(" "), _c('div', {
    staticClass: "t-comitente"
  }, [_c('img', {
    attrs: {
      "src": _vm.lote.comitente.imagemUrl
    }
  })]), _vm._v(" "), _vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(897)
    }
  })])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.4e822483ff9bc40334ee.js